import script from "./AcceleratorOscillator.vue?vue&type=script&lang=js"
export * from "./AcceleratorOscillator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__